/*
 * Kifoni — añadir al carrito desde el bloque de venta cruzada del drawer.
 *
 * POR QUÉ NO USA LA SECTION RENDERING API
 * ---------------------------------------
 * El drawer se pinta con {% render 'cart-drawer' %} desde layout/theme.liquid
 * (L440) y este tema NO tiene ninguna sección de carrito. Por eso el id
 * 'CartDrawer' que devuelve cart-drawer.js -> getSectionsToRender() no resuelve:
 * /cart/add.js responde {"sections":{"CartDrawer":null}}. Verificado 2026-08-25.
 *
 * Así que tras añadir repintamos .drawer__inner con el HTML de una carga normal
 * de página. Es una petición más, pero no depende de un id que no existe.
 * El contador de la cabecera sí tiene sección propia ('cart-icon-bubble'), que
 * sí resuelve, y se refresca aparte.
 *
 * Delegación en document: .drawer__inner se reemplaza entero en cada cambio,
 * así que cualquier listener enganchado a los botones se perdería.
 */
(function () {
  'use strict';

  var BUSY = 'kf-upsell--busy';

  function strings() {
    return (
      window.kfUpsellStrings || {
        adding: 'Añadiendo…',
        added: 'Añadido',
        error: 'No se ha podido añadir. Inténtalo de nuevo.',
      }
    );
  }

  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function showError(scope, message) {
    var box = scope ? scope.querySelector('[data-kf-upsell-error]') : null;
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
  }

  function onClick(event) {
    var button = event.target.closest('[data-kf-upsell-add]');
    if (!button || button.disabled) return;

    event.preventDefault();

    var variantId = button.dataset.variantId;
    var quantity = parseInt(button.dataset.quantity, 10) || 1;
    if (!variantId) return;

    // Dependencias que define el propio tema. Si faltan, degradamos a la ficha
    // de producto en vez de romper: mejor un clic de más que un error mudo.
    if (typeof fetchConfig !== 'function' || typeof routes === 'undefined' || !routes.cart_add_url) {
      var link = button.closest('.kf-upsell__card');
      var href = link ? link.querySelector('.kf-upsell__name') : null;
      if (href && href.href) window.location = href.href;
      return;
    }

    var scope = button.closest('[data-kf-upsell]');
    var label = button.querySelector('[data-kf-upsell-label]');
    var original = label ? label.textContent : '';
    var cart = getCart();

    button.disabled = true;
    button.classList.add(BUSY);
    if (label) label.textContent = strings().adding;

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    // Sólo la sección que sí existe. El drawer se repinta abajo, a mano.
    formData.append('sections', 'cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    function restore() {
      button.disabled = false;
      button.classList.remove(BUSY);
      if (label) label.textContent = original;
    }

    fetch(routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          // Shopify sólo devuelve `status` cuando algo ha ido mal.
          showError(scope, response.description || response.message || strings().error);
          restore();
          return;
        }

        if (label) label.textContent = strings().added;

        // Contador de la cabecera (esta sección sí resuelve).
        var bubbleHtml = (response.sections || {})['cart-icon-bubble'];
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubbleHtml && bubble) {
          var parsedBubble = new DOMParser()
            .parseFromString(bubbleHtml, 'text/html')
            .querySelector('.shopify-section');
          if (parsedBubble) bubble.innerHTML = parsedBubble.innerHTML;
        }

        return refreshDrawer();
      })
      .catch(function () {
        showError(scope, strings().error);
        restore();
      });
  }

  /*
   * Repinta .drawer__inner con el HTML de una carga normal de página: barra de
   * envío, líneas, totales y el propio bloque de sugerencias, todo coherente.
   *
   * NO toca el estado abierto/cerrado del cajón. Es deliberado:
   *  - El botón "Añadir" sólo existe DENTRO del cajón, así que ya está abierto.
   *    Llamar a open() es innecesario.
   *  - Y es dañino: esta petición tarda cientos de ms (segundos en móvil). Si el
   *    usuario cierra el carrito mientras está en vuelo, un open() tardío vuelve
   *    a poner 'active' (velo gris) y 'overflow-hidden' en el body (scroll
   *    bloqueado) con el panel ya fuera de pantalla: la tienda queda gris e
   *    inutilizable. Bug reportado por Victor en móvil, 2026-08-25.
   *  - Tampoco reengancha el listener del velo: #CartDrawer-Overlay es HERMANO
   *    de .drawer__inner, nunca se reemplaza, y su listener original sigue vivo.
   *    Reengancharlo sólo acumulaba duplicados.
   */
  function refreshDrawer() {
    var inner = document.querySelector('.drawer__inner');
    if (!inner) return;

    return fetch((typeof routes !== 'undefined' && routes.cart_url) || '/cart', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
        if (!fresh) return;

        // Repintamos siempre: si el cajón está cerrado, al reabrirlo estará al día.
        inner.innerHTML = fresh.innerHTML;

        var drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.classList.contains('active')) {
          drawer.classList.remove('is-empty');
          inner.classList.remove('is-empty');
        }

        // No hace falta avisar a kifoni-cart-rules.js: usa un MutationObserver
        // (L272) que cubre página y drawer, así que revalida los packs solo.
      });
  }

  document.addEventListener('click', onClick);
})();
